import { createBlock } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { colors } from 'styles/variables';
import { Block, cloneBlock, Blocks } from 'factories/block';
import { flatten } from 'factories/utils';
import Correct_default from 'assets/Correct_loop.gif';
import Incorrect_default from 'assets/Incorrect_loop.gif';

const { lPink, lGrey0, lGrey1, mint, purple } = colors;

export type ImageInteractionProps = InteractionProps & {};

const createAssessmentResults = (props?: {}) => {
  return createBlock(
    'AssessmentResults',
    [
      createFeedbackBlock('FeedbackPassed'),
      createFeedbackBlock('FeedbackFailed'),
    ],
    { props: {} }
  );
};

const createFeedbackBlock = type => {
  return createBlock(type, [
    createMediaBlock({
      src: type === 'FeedbackPassed' ? Correct_default : Incorrect_default,
    }),
    createBlock('Text'),
    createContinueBtn({}),
  ]);
};

const createContinueButtonBranchingBlock = props => {
  return createBlock('ContinueButtonBranching', [
    createContinueBtn({ ...props?.style, removeable: false }),
    createContinueBtn({
      style: props?.style,
      label: 'Passed',
      removeable: false,
    }),
    createContinueBtn({
      style: props?.style,
      label: 'Failed',
      removeable: false,
    }),
  ]);
};

export const addNewContinueButtonBranching = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.meta!.subType === 'ButtonBlock') {
    const buttonBlock = createContinueButtonBranchingBlock({});

    const buttonBlockRef = { id: buttonBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(buttonBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).push(buttonBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createAssessmentResultsInteractionBlock = (
  props,
  offset: number = 0
) => {
  return createBlock(
    'Interaction',
    [
      createAssessmentResults(),

      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            createBlock('RetryAssessment', [], {
              props: {
                type: 'RetryAssessment',
                label: 'Retry assessment',
                background: '#fff',
                color: '#060709',
                localColor: true,
                buttonOutline: true,
                localButtonOutline: true,
                removeable: false,
              },
            }),
            createContinueButtonBranchingBlock(props),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        type: 'AssessmentResults',
        name: props.name,
        sId: getSId('interaction', offset),
        style: props.style || {},
        graphColor: '#B2B6CA' || mint,
        showAttemptCounter: true,
        enableLearnMore: true,
        enableTryAgain: true,
        enableReVisit: true,
        includeResultsGraph: true,
        addAssessmentRetry: true,
        enableBranching: false,
        correctColor: '#B2B6CA' || mint,
        incorrectColor: '#1A1A2B' || purple,
        lockDown: 1,
      },
      meta: {
        subType: 'AssessmentResults',
      },
    }
  );
};

export const interactionConfig = {};
